<template>
    <div class="payment-overlay">
        <div class="payment-overlay--backdrop" @click="onBackgroundClicked"/>

        <button class="payment-overlay--navigation-button payment-overlay--navigation-button__prev"
                v-if="prevOverlay"
                @click="openPrevOverlay">
            <base-icon symbol="chevron-left" size="small"/>
        </button>

        <button class="payment-overlay--navigation-button payment-overlay--navigation-button__next"
                v-if="nextOverlay"
                @click="openNextOverlay">
            <base-icon symbol="chevron-right" size="small"/>
        </button>

        <div class="payment-overlay--content grid grid__base">
            <overlay-close-btn @close="onClose"/>

            <div class="payment-overlay-content payment-overlay-content__header grid grid__base">
                <div class="payment-overlay--header-row grid--row">
                    <div class="payment-overlay--header-col payment-overlay-content--content grid--col">
                        <h2 class="u-reset payment-overlay--title">{{ title }}</h2>
                    </div>
                    <div class="payment-overlay--header-logo-col grid--col">
                        <picture-element class="payment-overlay--logo" v-bind="logo"/>
                    </div>
                </div>
            </div>

            <div class="payment-overlay--content-wrapper"
                    v-if="overlayContent"
                    key="content">
                <v-runtime-template :template="overlayContent"/>
            </div>

            <div class="payment-overlay--loader-wrapper"
                    v-if="isContentLoading"
                    key="loader">
                <spinning-loader class="payment-overlay--loader"/>
            </div>

            <div class="payment-overlay--pagination grid--container" v-if="prevOverlay || nextOverlay">
                <div class="payment-overlay--pagination-row grid--row">
                    <div class="payment-overlay--pagination-col grid--col">
                        <button class="payment-overlay--mobile-navigation"
                                v-if="prevOverlay"
                                @click="openPrevOverlay">
                            <base-icon class="payment-overlay--mobile-navigation-icon"
                                    symbol="chevron-left"
                                    size="small"/>
                            {{ prevOverlay.name }}
                        </button>
                    </div>

                    <div class="payment-overlay--col grid--col">
                        <button class="payment-overlay--mobile-navigation"
                                v-if="nextOverlay"
                                @click="openNextOverlay">
                            {{ nextOverlay.name }}
                            <base-icon class="payment-overlay--mobile-navigation-icon"
                                    symbol="chevron-right"
                                    size="small"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';
    import Axios from 'util/service';
    import locationUtil from 'util/location';
    import SpinningLoader from 'framework/components/loaders/spinning-loader/spinning-loader';
    import VRuntimeTemplate from 'v-runtime-template';
    import OverlayCloseBtn from 'framework/global-components/dyn/overlay-close-btn/overlay-close-btn';

    export default {
        components: { OverlayCloseBtn, SpinningLoader, PictureElement, VRuntimeTemplate },
        props: {
            title: {
                type: String,
                required: true,
            },

            url: {
                type: String,
                required: true,
            },

            hash_id: {
                type: String,
                required: true,
            },

            /**
             * @type {ISvgImageSet}
             */
            logo: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                overlayContent: null,
                isContentLoading: false,
            };
        },

        computed: {
            ...mapGetters('overlay', ['currentOverlay']),
            ...mapGetters('payment-methods', ['getNextOverlay', 'getPrevOverlay']),

            nextOverlay() {
                return this.getNextOverlay(this.hash_id);
            },

            prevOverlay() {
                return this.getPrevOverlay(this.hash_id);
            },
        },

        methods: {
            ...mapActions('overlay', ['openOverlay', 'closeOverlay']),
            ...mapActions('scroll', ['disableScroll']),

            openNextOverlay() {
                if (!this.nextOverlay) {
                    return;
                }
                this.openOverlay({ id: this.nextOverlay.overlayId });
            },

            openPrevOverlay() {
                if (!this.prevOverlay) {
                    return;
                }
                this.openOverlay({ id: this.prevOverlay.overlayId });
            },

            onBackgroundClicked() {
                this.closeOverlay({ id: this.currentOverlay.id });
            },

            onClose() {
                locationUtil.clearHash();
            },
        },

        beforeDestroy() {
            this.disableScroll({ isLocked: false });
        },

        mounted() {
            this.isContentLoading = true;
            locationUtil.setHash(this.hash_id);


            this.disableScroll({ isLocked: true });

            Axios.get(this.url)
                .then((response) => {
                    this.overlayContent = response.data;
                    this.isContentLoading = false;
                })
                .catch(() => {
                    this.isContentLoading = false;
            });
        },
    };
</script>
